import { render } from "./country-attachment.vue?vue&type=template&id=0bf8c201"
import script from "./country-attachment.vue?vue&type=script&lang=js"
export * from "./country-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__